import { z } from 'zod';

/**
 * Our CSP has no `unsafe-eval`, so zod's JIT validator codegen (`new Function` in
 * `zod/v4/core/doc.js`) trips a `securitypolicyviolation`. zod reads this flag when a
 * schema is *constructed*, so it must be set before the first `z.object()` call.
 *
 * Living here rather than in `instrumentation-client.ts` keeps zod out of every app's
 * eager bundle: this module loads only where zod already loads, and ES module
 * evaluation guarantees the call below runs before any importer builds a schema.
 *
 * Import zod from this module, never from `zod` directly (enforced by `no-restricted-imports`).
 */
z.config({ jitless: true });

export { z };
